/* eslint-disable */
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined"; import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ClosedCaptionDisabledIcon from '@mui/icons-material/ClosedCaptionDisabled';
import SearchIcon from "@mui/icons-material/Search";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Add } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers";
import { useEffect, useState, useContext } from "react";
import { getTarjetasDebito } from "../../../project/services/MedioCobroService";
import { getTarjetasCredito } from "../../../project/services/MedioCobroService";
import { getObraSocialPlanes } from "../../../project/services/ObraSocialPlanService";
import { getCacheData } from "../../services/CacheService";
import { getCajas, iniciarCaja, borrarCaja } from "../../../project/services/CajaService";
import Message from "../../../project/utils/Message";
import BuscarClienteDialog from "../gestion-atencion/BuscarClienteDialog";
import CajaCierreDialog from "./CajaCierreDialog";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  codigoCaja: "",
  fechaCreacionDesde: null,
  fechaCreacionHasta: null,
  estadoActual: "todo",
  usuario: "",
  codigoGA: "",
  nombre: "",
  apellido: "",
  tipoCobro: "",
  tarjetaDebito: "",
  numeroCuponTarjetaDebito: "",
  numeroLoteTarjetaDebito: "",
  tarjetaCredito: "",
  numeroCuponTarjetaCredito: "",
  numeroLoteTarjetaCredito: "",
  billetera: "",
  obraSocial: "",
  descripcionObraSocial: "",
  obraSocialPlan: "",
  descripcionObraSocialPlan: "",
  numeroBeneficiario: "",
  numeroAutorizacion: "",
  descripcionDescuentoEspecial: "",
  descripcionOtraFormadeCobro: "",
  cuentaBancaria: "",
  banco: "",
  numeroCheque: "",
  tipoAjuste: "",
  descripcionAjuste: "",
  tipoComprobante: "",
  descripcionComprobante: "",
  numeroComprobante: "",
  proveedor: "",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "abierta",
    descripcion: "Abierta",
  },
  {
    id: "cerrada",
    descripcion: "Cerrada",
  },
  {
    id: "revision",
    descripcion: "Revisión",
  },
];

const mediosDeCobroOptions = [
  {
    id: "efectivo",
    label: "Efectivo",
  },
  {
    id: "tarjeta-debito",
    label: "Tarjeta de Débito",
  },
  {
    id: "tarjeta-credito",
    label: "Tarjeta de Crédito",
  },
  {
    id: "billetera-virtual",
    label: "Billetera Virtual",
  },
  {
    id: "obra-social",
    label: "Obra Social",
  },
  {
    id: "descuento-especial",
    label: "Descuento especial",
  },
  {
    id: "otro",
    label: "Otra forma de pago",
  },
  {
    id: "transferencia-bancaria",
    label: "Transferencia Bancaria",
  },
  {
    id: "cheque",
    label: "Cheque",
  },
];

const nameItemsText = "Cajas";
//
// #############################################################################  
//
const CajaTable = () => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [tarjetasDebito, setTarjetasDebito] = useState([]);
  const [tarjetasCredito, setTarjetasCredito] = useState([]);
  const [cuentasBancarias, setCuentasBancarias] = useState([]);
  const [billeteras, setBilleteras] = useState([]);
  const [obrasSociales, setObrasSociales] = useState([]);
  const [obraSocialPlanes, setObraSocialPlanes] = useState([]);
  const [tiposAjuste, setTiposAjuste] = useState([]);
  const [tiposComprobante, setTiposComprobante] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [usuarios, setUsuarios] = useState([])
  const [cajas, setCajas] = useState([]);
  const [CajaSelected, setCajaSelected] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [valueACMedioDeCobro, setValueACMedioDeCobro] =
    useState({ id: "", label: "" });
  const [
    inputValueACMedioDeCobro,
    setInputValueACMedioDeCobro,
  ] = useState("");
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [tipoMovimiento, setTipoMovimiento] = useState("todos");
  const [disabledtipoMovimiento, setDisabledtipoMovimiento] = useState(false);
  const [iniciar, setIniciar] = useState(true)
  const [valueACObraSocial, setValueACObraSocial] = useState({
    id: "",
    descripcion: ""
  });
  const [inputValueACObraSocial, setInputValueACObraSocial] = useState("");
  const [valueACObraSocialPlan, setValueACObraSocialPlan] = useState({
    id: "",
    descripcion_obra_social_plan: "",
    id_obra_social: "",
  });
  const [inputValueACObraSocialPlan, setInputValueACObraSocialPlan] = useState("");
  const [obraSocialPlanesTmp, setObraSocialPlanesTmp] = useState([]);
  const [openDialogCajaCierre, setOpenDialogCajaCierre] = useState(false);
  const [idCaja, setIdCaja] = useState(null);
  const [codigoCaja, setCodigoCaja] = useState('');
  const [estadoCaja, setEstadoCaja] = useState('');

  const { hasPermission } = useContext(AuthContext);
  const _editarCaja = hasPermission("caja-b");
  const _iniciarCaja = hasPermission("caja-c");
  const _cerrarCaja = hasPermission("caja-cerrar");
  const _borrarCaja = hasPermission("caja-el");

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = "ERR";
        switch (params.row.estado) {
          case "abierta":
            _val = <span style={{ color: 'green' }}>ABIERTA</span>
            break;
          case "cerrada":
            _val = <span style={{ color: 'black' }}>CERRADA</span>
            break;
          case "revision":
            _val = <span style={{ color: 'blue' }}>REVISIÓN</span>
            break;
        }
        return _val;
      },
    },
    {
      field: "fecha_creacion",
      headerName: "Fecha de Creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_creacion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "saldo_apertura",
      headerName: "Saldo de apertura",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.saldo_apertura;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "saldo_cierre",
      headerName: "Saldo de cierre",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.saldo_cierre;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="ver caja">
            <IconButton
              size="small"
              aria-label="update"
              onClick={() => obtenerCaja(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>

          {/* mostrar editar solamente si la caja está abierta */}
          {params.row.estado === "abierta" && _editarCaja && (
            <Tooltip title="editar caja">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => editarCaja(params.row, "update")}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.estado !== "cerrada" && _cerrarCaja && (
            <Tooltip title="revisar >> cerrar caja">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => revisarCaja(params.row)}
              >
                <ClosedCaptionDisabledIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.removable !== false && params.row.estado === "abierta" && _borrarCaja && (
            <Tooltip title="borrar caja">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() => borrarCajaAbierta(params.row)}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
        </>),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    localeText: {
      noRowsLabel: "No se encontraron registros",
      noResultsOverlayLabel: "No se encontraron registros",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadTarjetasDebito();
    loadTarjetasCredito();
    loadCuentasBancarias();
    loadBilleteras();
    loadObrasSociales();
    loadObraSocialPlanes();
    loadTiposAjuste();
    loadTiposComprobante();
    loadProveedores();
    loadUsuarios();

    setValueACObraSocial({
      id: searchData.obraSocial,
      descripcion: searchData.descripcionObraSocial,
    });
    setValueACObraSocialPlan({
      id: searchData.obraSocialPlan,
      descripcion_obra_social_plan: searchData.descripcionObraSocialPlan,
      id_obra_social: searchData.obraSocial,
    });
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (valueACObraSocial.id !==
      valueACObraSocialPlan.id_obra_social) {
      setValueACObraSocialPlan({
        id: "",
        descripcion_obra_social_plan: "",
        id_obra_social: "",
      });
      setObraSocialPlanesTmp([]);
      if (valueACObraSocial) {
        setObraSocialPlanesTmp
          (obraSocialPlanes.filter((item) => {
            return item.id_obra_social === valueACObraSocial.id
              ? item
              : null;
          }));
      }
    }
  }, [valueACObraSocial])
  //
  // ################################################################################
  //
  const loadTarjetasDebito = async () => {
    const response = await getTarjetasDebito();
    if (response.ok) {
      let _tarjetasDebito = [];
      let _tarjeta = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion =
          item.marca_tarjeta.toUpperCase() +
          " - " +
          item.banco_entidad.toUpperCase() +
          (item.porcentaje_descuento > 0
            ? " - " + item.porcentaje_descuento + " % descuento"
            : "");

        _tarjeta = {
          idTarjeta: item.id_tarjeta,
          idTarjetaBanco: item.id_tarjeta_banco,
          idTarjetaBancoAcuerdo: item.id_tarjeta_banco_acuerdo,
          id: item.id_tarjeta_banco_acuerdo,
          porcentajeDescuento: item.porcentaje_descuento,
          tarjeta: _descripcion,
          label: _descripcion,
        };
        _tarjetasDebito.push(_tarjeta);
      });
      setTarjetasDebito(_tarjetasDebito);
    } else {
      setTarjetasDebito([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTarjetasCredito = async () => {
    const response = await getTarjetasCredito();
    if (response.ok) {
      let _tarjetasCredito = [];
      let _tarjeta = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion =
          item.marca_tarjeta.toUpperCase() +
          " - " +
          item.banco_entidad.toUpperCase() +
          " - " +
          item.cantidad_cuotas +
          (item.cantidad_cuotas === 1 ? " cuota" : " cuotas") +
          (item.porcentaje_descuento > 0
            ? " - " + item.porcentaje_descuento + " % descuento"
            : "") +
          (item.porcentaje_interes > 0 ? " - " + item.porcentaje_interes + " % interés" : "");
        _tarjeta = {
          idTarjeta: item.id_tarjeta,
          idTarjetaBanco: item.id_tarjeta_banco,
          idTarjetaBancoAcuerdo: item.id_tarjeta_banco_acuerdo,
          id: item.id_tarjeta_banco_acuerdo,
          porcentajeDescuento: item.porcentaje_descuento,
          porcentajeInteres: item.porcentaje_interes,
          cantidadCuotas: item.cantidad_cuotas,
          tarjeta: _descripcion,
          label: _descripcion,
        };
        _tarjetasCredito.push(_tarjeta);
      });
      setTarjetasCredito(_tarjetasCredito);
    } else {
      setTarjetasCredito([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadCuentasBancarias = async () => {
    const response = await getCacheData("cuenta_bancaria");
    if (response.ok) {
      let _cuentasBancarias = [];
      let _cuentaBancaria = {};
      let _descripcion = "";
      response.data.data.forEach((item) => {
        _descripcion = item.banco.toUpperCase() + " - CBU: " + item.numero_cbu.toUpperCase();
        _cuentaBancaria = {
          id: item.id,
          idCuentaBancaria: item.id,
          bancoCuentaBancaria: _descripcion,
          label: _descripcion,
        };
        _cuentasBancarias.push(_cuentaBancaria);
      });
      setCuentasBancarias(_cuentasBancarias);
    } else {
      setCuentasBancarias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBilleteras = async () => {
    const response = await getCacheData("billetera");
    if (response.ok) {
      setBilleteras(response.data.data);
    } else {
      setBilleteras([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadObrasSociales = async () => {
    const response = await getCacheData("obra_social");
    if (response.ok) {
      setObrasSociales(response.data.data);
    } else {
      setObrasSociales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadObraSocialPlanes = async () => {
    const response = await getObraSocialPlanes();
    if (response.ok) {
      setObraSocialPlanes(response.data.data);
    } else {
      setObraSocialPlanes([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTiposAjuste = async () => {
    const response = await getCacheData("tipo_ajuste");
    if (response.ok) {
      setTiposAjuste(response.data.data);
    } else {
      setTiposAjuste([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTiposComprobante = async () => {
    const response = await getCacheData("tipo_comprobante");
    if (response.ok) {
      setTiposComprobante(response.data.data);
    } else {
      setTiposComprobante([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor")
    if (response.ok) {
      setProveedores(response.data.data);
    } else {
      setProveedores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadUsuarios = async () => {
    const response = await getCacheData("usuario");
    if (response.ok) {
      setUsuarios(response.data.data);
    } else {
      setUsuarios([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setValueACMedioDeCobro({ id: "", label: "" });
    setInputValueACMedioDeCobro("");
    setValueACObraSocial({ id: "", descripcion: "" });
    setInputValueACObraSocial("");
    setValueACObraSocialPlan({
      id: "",
      descripcion_obra_social_plan: "",
      id_obra_social: "",
    });
    setInputValueACObraSocialPlan("");
    setTotalRowsCount(0);
    setCajas([]);
    setCajaSelected([]);
    setTipoMovimiento("todos");
    setCurrentPage(0);
  };
  //
  // ################################################################################
  //
  const handleBorrarMovimiento = () => {
    setSearchData(initialSearchData);
    setValueACMedioDeCobro({ id: "", label: "" });
    setInputValueACMedioDeCobro("");
    setTotalRowsCount(0);
    setCajas([]);
    setCajaSelected([]);
    setCurrentPage(0);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage === 0) {
      load();
    } else {
      setCurrentPage(0);
    }
  };
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // ################################################################################
  // 
  const load = async () => {
    let _params = {
      codigoCaja: searchData.codigoCaja,
      fechaCreacionDesde: searchData.fechaCreacionDesde,
      fechaCreacionHasta: searchData.fechaCreacionHasta,
      estadoActual: searchData.estadoActual,
      usuario: searchData.usuario,
      codigoGA: searchData.codigoGA,
      nombre: searchData.nombre,
      apellido: searchData.apellido,
      tipoCobro: searchData.tipoCobro,
      tarjetaDebito: searchData.tarjetaDebito,
      numeroCuponTarjetaDebito: searchData.numeroCuponTarjetaDebito,
      numeroLoteTarjetaDebito: searchData.numeroLoteTarjetaDebito,
      tarjetaCredito: searchData.tarjetaCredito,
      numeroCuponTarjetaCredito: searchData.numeroCuponTarjetaCredito,
      numeroLoteTarjetaCredito: searchData.numeroLoteTarjetaCredito,
      billetera: searchData.billetera,
      obraSocial: valueACObraSocial.id,
      obraSocialPlan: valueACObraSocialPlan.id,
      numeroBeneficiario: searchData.numeroBeneficiario,
      numeroAutorizacion: searchData.numeroAutorizacion,
      descripcionDescuentoEspecial: searchData.descripcionDescuentoEspecial,
      descripcionOtraFormadeCobro: searchData.descripcionOtraFormadeCobro,
      cuentaBancaria: searchData.cuentaBancaria,
      numeroComprobante: searchData.numeroComprobante,
      banco: searchData.banco,
      numeroCheque: searchData.numeroCheque,
      clienteId: searchData.idCliente,
      tipoMovimiento: tipoMovimiento,
      tipoAjuste: searchData.tipoAjuste,
      descripcionAjuste: searchData.descripcionAjuste,
      tipoComprobante: searchData.tipoComprobante,
      descripcionComprobante: searchData.descripcionComprobante,
      proveedor: searchData.proveedor,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getCajas(_params);
    setIsDoingSomething(false);

    if (response.ok) {

      let _cajas = response.data.data || [];
      // chequear si en el arreglo existe una caja abierta o en revision 

      let _iniciar = true;
      _cajas.forEach((item) => {
        if (item.estado === "abierta" || item.estado === "revision") {
          _iniciar = false;
          setIniciar(false);
        }
      });

      setCajas(_cajas);
      if (_cajas.length > 0) {
        setCodigoCaja(_cajas[0].codigo);
        setEstadoCaja(_cajas[0].estado);
      }
      setTotalRowsCount(response.data.count ?? 0);
      setCajaSelected([]);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ###############################################################################
  //
  const obtenerCaja = (parRow, parAction) => {

    let _id = parRow.id;
    let _codigo = parRow.codigo;
    let _estado = parRow.estado;
    let _url = `/caja/${_id}/${parAction}`;

    // ahora los guardo en sessionStorage
    sessionStorage.setItem("codigoCaja", _codigo);
    sessionStorage.setItem("estadoCaja", _estado);
    sessionStorage.setItem("idCaja", _id);

    window.open(_url, "_blank");
  };
  //
  // ################################################################################
  //
  const editarCaja = (parRow, parAction) => {

    let _aditionalData = {
      codigoCaja: parRow.codigo,
      estadoCaja: parRow.estado,
    }
    let _id = parRow.id;
    navigate("/caja/" + _id + "/" + parAction, { state: _aditionalData });
  }
  //
  // ################################################################################
  //
  const revisarCaja = async (parRow) => {
    setIdCaja(parRow.id);
    setOpenDialogCajaCierre(true);
  }
  //
  // ################################################################################
  //
  const handleCloseBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // ################################################################################
  //
  const handleCloseCajaCierre = () => {
    setOpenDialogCajaCierre(false);
    load();
  };
  //  
  // ################################################################################ 
  //
  // inciarCaja
  const handleInciarCaja = async () => {
    setIsDoingSomething(true);
    const response = await iniciarCaja();
    setIsDoingSomething(false);
    if (response.ok) {
      load();
      setIniciar(false);
    }

    setMessage({
      severity: response.messageSeverity,
      messageText: response.messageText,
    });
    setShowMessage(true);
  }
  //
  // ################################################################################
  //
  const handleSelectBusquedaCliente = (cliente) => {
    setOpenDialogBusquedaAvanzada(false);
    setSearchData({
      ...searchData,
      nombre: cliente.nombre,
      apellido: cliente.apellido,
      idCliente: cliente.id,
    });
  }
  //
  // ################################################################################
  //
  const handleChangeTipoMovimiento = (event, newValue) => {
    setTipoMovimiento(newValue);
    setDisabledtipoMovimiento(false);
    handleBorrarMovimiento();
  }
  //
  // ################################################################################
  //
  const handleNuevaCaja = () => {
    handleInciarCaja();
  }
  //
  // ################################################################################
  //
  const borrarCajaAbierta = async (parRow) => {

    setIsDoingSomething(true);
    const response = await borrarCaja(parRow.id);
    setIsDoingSomething(false);

    if (response.ok) {
      load();
      setIniciar(true);
    }
    setMessage({
      severity: response.messageSeverity,
      messageText: response.messageText,
    });
    setShowMessage(true);
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoCaja"
                  label="Código de Caja"
                  variant="outlined"
                  size="small"
                  name="codigoCaja"
                  value={searchData.codigoCaja}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    '& .MuiInputLabel-root': {
                      transform: 'translate(14px, 9px) scale(1)',
                    },
                    '& .MuiInputBase-root': {
                      paddingRight: '10px',
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -8px) scale(0.75)',
                    },
                  }}
                  id="fechaCreacionDesde"
                  label="Creación Desde Fecha"
                  variant="outlined"
                  size="small"
                  name="fechaCreacionDesde"
                  value={searchData.fechaCreacionDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionDesde(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    '& .MuiInputLabel-root': {
                      transform: 'translate(14px, 9px) scale(1)',
                    },
                    '& .MuiInputBase-root': {
                      paddingRight: '10px',
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -8px) scale(0.75)',
                    },
                  }}
                  id="fechaCreacionHasta"
                  label="Creación hasta fecha"
                  variant="outlined"
                  name="fechaCreacionHasta"
                  value={searchData.fechaCreacionHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionHasta(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="estado-actual-select-label">Estado actual</InputLabel>
                  <Select
                    labelId="estado-actual-select-label"
                    id="estado-actual-select"
                    name="estadoActual"
                    value={searchData.estadoActual}
                    label="Estado actual"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel
                    id="usuario-select-label"
                    sx={{
                      transform: "translate(15px, 10px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                      },
                    }}
                  >
                    Usuario
                  </InputLabel>
                  <Select
                    labelId="usuario-select-label"
                    id="usuario-select"
                    name="usuario"
                    value={searchData.usuario}
                    label="Vendedor"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {usuarios.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.nombre}, {item.apellido}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={12}>
                <Typography variant="h6" display="cristal" gutterBottom >
                  Tipo de Movimiento
                </Typography>

                <Box sx={{ mb: 1 }}>
                  <ToggleButtonGroup
                    color="primary"
                    size="small"
                    value={tipoMovimiento}
                    exclusive={true}
                    onChange={handleChangeTipoMovimiento}
                    disabled={false}
                  >
                    <ToggleButton
                      value="todos"
                      sx={{ mr: 1, onblur: "#1976d2", color: "#1976d2", borderColor: "#1976d2", width: 'auto', minWidth: '150px' }}
                      size="small"
                      disabled={disabledtipoMovimiento}
                    >
                      Todos
                    </ToggleButton>

                    <ToggleButton
                      value="cobranza"
                      sx={{ mr: 1, onblur: "#1976d2", color: "#1976d2", borderColor: "#1976d2", width: 'auto', minWidth: '150px' }}
                      size="small"
                      disabled={disabledtipoMovimiento}
                    >
                      cobranza
                    </ToggleButton>

                    <ToggleButton
                      value="ajuste"
                      sx={{ mr: 1, onblur: "#1976d2", color: "#1976d2", borderColor: "#1976d2", width: 'auto', minWidth: '150px' }}
                      size="small"
                      disabled={disabledtipoMovimiento}
                    >
                      ajuste
                    </ToggleButton>

                    <ToggleButton
                      value="gasto"
                      sx={{ mr: 1, onblur: "#1976d2", color: "#1976d2", borderColor: "#1976d2", width: 'auto', minWidth: '150px' }}
                      size="small"
                      disabled={disabledtipoMovimiento}
                    >
                      gasto
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>

                {tipoMovimiento === "cobranza" && (
                  <>
                    <Box sx={{ mt: 1, mr: 2, mb: 3 }}>
                      <Grid container spacing={1} sx={{ mb: 1 }}>
                        <Grid item xs={12} md={12} lg={2}>
                          <TextField
                            sx={{ width: "100%" }}
                            inputProps={{
                              autoComplete: "off",
                            }}
                            id="nombre"
                            label="Nombre de Cliente"
                            variant="outlined"
                            size="small"
                            name="nombre"
                            disabled={true}
                            value={searchData.nombre}
                            onChange={handleChange}
                          />
                        </Grid>

                        <Grid item xs={12} md={12} lg={2}>
                          <TextField
                            sx={{ width: "100%" }}
                            inputProps={{
                              autoComplete: "off",
                            }}
                            id="apellido"
                            label="Apellido de Cliente"
                            variant="outlined"
                            size="small"
                            name="apellido"
                            disabled={true}
                            value={searchData.apellido}
                            onChange={handleChange}
                          />
                        </Grid>

                        <Grid item xs={12} md={12} lg={2}>
                          <Button
                            sx={{ width: "100%" }}
                            variant="contained"
                            onClick={handleClickOpenBusquedaAvanzada}
                            startIcon={<SavedSearchIcon />}
                          >
                            Cliente
                          </Button>
                        </Grid>
                      </Grid>

                      <Box sx={{ mb: 1 }}>
                        <Grid item xs={12} md={12} lg={2}>
                          <Autocomplete
                            id="mediosDeCobro"
                            size="small"
                            value={valueACMedioDeCobro}
                            onChange={(event, newValue) => {
                              setValueACMedioDeCobro(newValue);
                              setSearchData((prevData) => ({
                                ...prevData,
                                tipoCobro: newValue || newValue.id ? newValue.id : "",
                              }));
                            }}
                            inputValue={inputValueACMedioDeCobro}
                            onInputChange={(event, newInputValue) => {
                              setInputValueACMedioDeCobro(newInputValue);
                            }}
                            options={mediosDeCobroOptions}
                            renderInput={(params) => (
                              <TextField {...params} label="Medio de Cobro" />
                            )}
                            isOptionEqualToValue={(option, value) =>
                              value === null || option.value === value.value
                            }
                            disableClearable={true}
                          />
                        </Grid>
                      </Box>

                      {valueACMedioDeCobro.id === "tarjeta-debito" && (
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={12} lg={2}>
                            <FormControl sx={{ width: "100%" }}>
                              <InputLabel id="tarjeta-debito-select-label">
                                Tarjeta de Débito
                              </InputLabel>
                              <Select
                                labelId="tarjeta-debito-select-label"
                                id="tarjeta-debito-select"
                                name="tarjetaDebito"
                                value={searchData.tarjetaDebito}
                                label="Tarjeta de Débito"
                                size="small"
                                sx={{ mb: 1 }}
                                onChange={handleChange}
                                MenuProps={{ style: { maxHeight: "300px" } }}
                              >
                                {tarjetasDebito.map((item) => (
                                  <MenuItem
                                    key={item.idTarjetaBancoAcuerdo}
                                    value={item.idTarjetaBancoAcuerdo}
                                  >
                                    {item.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroCuponTarjetaDebito"
                              label="Número de Cupón"
                              variant="outlined"
                              size="small"
                              name="numeroCuponTarjetaDebito"
                              value={searchData.numeroCuponTarjetaDebito}
                              onChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroLoteTarjetaDebito"
                              label="Número de Lote"
                              variant="outlined"
                              size="small"
                              name="numeroLoteTarjetaDebito"
                              value={searchData.numeroLoteTarjetaDebito}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {valueACMedioDeCobro.id === "tarjeta-credito" && (
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={12} lg={2}>
                            <FormControl sx={{ width: "100%", mb: 1 }}>
                              <InputLabel id="tarjeta-credito-select-label">
                                Tarjeta de Crédito
                              </InputLabel>
                              <Select
                                labelId="tarjeta-credito-select-label"
                                id="tarjeta-credito-select"
                                name="tarjetaCredito"
                                value={searchData.tarjetaCredito}
                                label="Tarjeta de Crédito"
                                size="small"
                                onChange={handleChange}
                                MenuProps={{ style: { maxHeight: "300px" } }}
                              >
                                {tarjetasCredito.map((item) => (
                                  <MenuItem
                                    key={item.idTarjetaBancoAcuerdo}
                                    value={item.idTarjetaBancoAcuerdo}
                                  >
                                    {item.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroCuponTarjetaCredito"
                              label="Número de Cupón"
                              variant="outlined"
                              size="small"
                              name="numeroCuponTarjetaCredito"
                              value={searchData.numeroCuponTarjetaCredito}
                              onChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroLoteTarjetaCredito"
                              label="Número de Lote"
                              variant="outlined"
                              size="small"
                              name="numeroLoteTarjetaCredito"
                              value={searchData.numeroLoteTarjetaCredito}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {valueACMedioDeCobro.id === "billetera-virtual" && (
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={12} lg={2}>
                            <FormControl sx={{ width: "100%" }}>
                              <InputLabel id="billetera-select-label">
                                Billetera Virtual
                              </InputLabel>
                              <Select
                                labelId="billetera-select-label"
                                id="billetera-select"
                                name="billetera"
                                value={searchData.billetera}
                                label="Billetera"
                                size="small"
                                onChange={handleChange}
                                MenuProps={{ style: { maxHeight: "300px" } }}
                              >
                                {billeteras.map((item) => (
                                  <MenuItem key={item.id} value={item.id}
                                  >
                                    {item.descripcion}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      )}

                      {valueACMedioDeCobro.id === "obra-social" && (
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={12} lg={2}>
                            <FormControl fullWidth sx={{ width: "100%", mb: 1 }}>
                              <Autocomplete
                                size="small"
                                value={valueACObraSocial}
                                onChange={(event, newValue) => {
                                  setValueACObraSocial(newValue);
                                }}
                                inputValue={inputValueACObraSocial}
                                onInputChange={(event, newInputValue) => {
                                  setInputValueACObraSocial(newInputValue);
                                }}
                                options={obrasSociales}
                                renderInput={(params) => (
                                  <TextField {...params} label="Obras Sociales" />
                                )}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                getOptionLabel={(option) => option.descripcion ?? option}
                                disableClearable={true}
                              />
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={12} lg={2}>
                            <FormControl sx={{ width: "100%", mb: 1 }}>
                              <Autocomplete
                                size="small"
                                value={valueACObraSocialPlan}
                                onChange={(event, newValue) => {
                                  setValueACObraSocialPlan(newValue);
                                }}
                                inputValue={inputValueACObraSocialPlan}
                                onInputChange={(event, newInputValue) => {
                                  setInputValueACObraSocialPlan(newInputValue);
                                }}
                                options={obraSocialPlanesTmp}
                                renderInput={(params) => (
                                  <TextField {...params} label="Planes de Obra Social" />
                                )}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                getOptionLabel={(option) =>
                                  option.descripcion_obra_social_plan ?? option
                                }
                                disableClearable={true}
                              />
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroBeneficiario"
                              label="Número de Beneficiario"
                              variant="outlined"
                              size="small"
                              name="numeroBeneficiario"
                              value={searchData.numeroBeneficiario}
                              onChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroAutorizacion"
                              label="Número de Autorización"
                              variant="outlined"
                              size="small"
                              name="numeroAutorizacion"
                              value={searchData.numeroAutorizacion}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {valueACMedioDeCobro.id === "descuento-especial" && (
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="descripcionDescuentoEspecial"
                              label="Descripción"
                              variant="outlined"
                              size="small"
                              name="descripcionDescuentoEspecial"
                              value={searchData.descripcionDescuentoEspecial}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {valueACMedioDeCobro.id === "otro" && (
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="descripcionOtraFormadeCobro"
                              label="Descripción"
                              variant="outlined"
                              size="small"
                              name="descripcionOtraFormadeCobro"
                              value={searchData.descripcionOtraFormadeCobro}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {valueACMedioDeCobro.id ===
                        "transferencia-bancaria" && (
                          <Grid container spacing={1}>
                            <Grid item xs={12} md={12} lg={2}>
                              <FormControl sx={{ width: "100%", mb: 1 }}>
                                <InputLabel id="cuenta-bancaria-select-label">
                                  Cuenta Bancaria
                                </InputLabel>
                                <Select
                                  labelId="cuenta-bancaria-select-label"
                                  id="cuenta-bancaria-select"
                                  name="cuentaBancaria"
                                  value={searchData.cuentaBancaria}
                                  label="Cuenta Bancaria"
                                  size="small"
                                  onChange={handleChange}
                                  MenuProps={{ style: { maxHeight: "300px" } }}
                                >
                                  {cuentasBancarias.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item xs={12} md={12} lg={2}>
                              <TextField
                                sx={{ width: "100%" }}
                                inputProps={{
                                  autoComplete: "off",
                                }}
                                id="numeroComprobante"
                                label="Número de Comprobante"
                                variant="outlined"
                                size="small"
                                name="numeroComprobante"
                                value={searchData.numeroComprobante}
                                onChange={handleChange}
                              />
                            </Grid>
                          </Grid>
                        )}

                      {valueACMedioDeCobro.id === "cheque" && (
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="banco"
                              label="Banco"
                              variant="outlined"
                              size="small"
                              name="banco"
                              value={searchData.banco}
                              onChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12} md={12} lg={2}>
                            <TextField
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroCheque"
                              label="Número de Cheque"
                              variant="outlined"
                              size="small"
                              name="numeroCheque"
                              value={searchData.numeroCheque}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )}
                    </Box>
                  </>
                )}

                {tipoMovimiento === "gasto" && (
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={12} lg={2}>
                      <FormControl sx={{ width: "100%", mb: 1 }}>
                        <InputLabel id="tipo-comprobante-select-label">
                          Tipo de Comprobante
                        </InputLabel>
                        <Select
                          labelId="tipo-comprobante-select-label"
                          id="tipo-comprobante-select"
                          name="tipoComprobante"
                          value={searchData.tipoComprobante}
                          label="Tipo de Comprobante"
                          size="small"
                          onChange={handleChange}
                          MenuProps={{ style: { maxHeight: "300px" } }}
                        >
                          {tiposComprobante.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.descripcion}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12} lg={2}>
                      <TextField
                        sx={{ width: "100%", mb: 1 }}
                        inputProps={{
                          autoComplete: "off",
                        }}
                        id="descripcionComprobante"
                        label="Descripción"
                        variant="outlined"
                        size="small"
                        name="descripcionComprobante"
                        value={searchData.descripcionComprobante}
                        onChange={handleChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={12} lg={2}>
                      <FormControl sx={{ width: "100%", mb: 1 }}>
                        <InputLabel id="proveedor-select-label">
                          Proveedor
                        </InputLabel>
                        <Select
                          labelId="proveedor-select-label"
                          id="proveedor"
                          name="proveedor"
                          value={searchData.proveedor}
                          label="Proveedor"
                          size="small"
                          onChange={handleChange}
                          MenuProps={{ style: { maxHeight: "300px" } }}
                        >
                          {proveedores.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.descripcion}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12} lg={2}>
                      <TextField
                        sx={{ width: "100%", mb: 1 }}
                        inputProps={{
                          autoComplete: "off",
                        }}
                        id="numeroComprobante"
                        label="N° de Comprobante"
                        variant="outlined"
                        size="small"
                        name="numeroComprobante"
                        value={searchData.numeroComprobante}
                        onChange={handleChange}
                      />
                    </Grid>
                  </Grid>
                )}

                {tipoMovimiento === "ajuste" && (
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={12} lg={2}>
                      <FormControl sx={{ width: "100%" }}>
                        <InputLabel id="tipo-ajuste-select-label">
                          Tipo de Ajuste
                        </InputLabel>
                        <Select
                          labelId="tipo-ajuste-select-label"
                          id="tipo-ajuste-select"
                          name="tipoAjuste"
                          value={searchData.tipoAjuste}
                          label="Tipo de Ajuste"
                          size="small"
                          onChange={handleChange}
                          MenuProps={{ style: { maxHeight: "300px" } }}
                        >
                          {tiposAjuste.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.descripcion}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12} lg={2}>
                      <TextField
                        sx={{ width: "100%" }}
                        inputProps={{
                          autoComplete: "off",
                        }}
                        id="descripcionAjuste"
                        label="Descripción"
                        variant="outlined"
                        size="small"
                        name="descripcionAjuste"
                        value={searchData.descripcionAjuste}
                        onChange={handleChange}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid container spacing={1}>
                {_iniciarCaja && (
                  <Grid item xs={12} md={12} lg={1.5}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Tooltip title="iniciar caja">
                        <Button
                          fullWidth
                          className={iniciar ? "btn-add" : ""}
                          variant="contained"
                          size="small"
                          onClick={handleNuevaCaja}
                          disabled={iniciar === false}
                          startIcon={<Add />}
                          sx={
                            iniciar === false
                              ? {
                                mt: 2,
                                ml: 1,
                                backgroundColor: "#e8e8e8",
                                color: "#9e9e9e",
                                "&.Mui-disabled": {
                                  backgroundColor: "#e8e8e8",
                                  color: "#9e9e9e",
                                },
                              }
                              : {}
                          }
                        >
                          Iniciar caja
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>
                )}

                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="buscar">
                      <Button
                        fullWidth
                        sx={{ mt: 2 }}
                        variant="contained"
                        size="small"
                        onClick={handleBuscar}
                        startIcon={<SearchIcon />}
                      >
                        Buscar
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="limpiar filtros de búsqueda">
                      <Button
                        fullWidth
                        sx={{ mt: 2 }}
                        variant="outlined"
                        size="small"
                        onClick={handleLimpiar}
                        startIcon={<CleaningServicesIcon />}
                      >
                        Limpiar
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper >

        <DataGrid
          rows={cajas}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper >

      {
        openDialogBusquedaAvanzada && (
          <BuscarClienteDialog
            open={openDialogBusquedaAvanzada}
            onClose={handleCloseBusquedaAvanzada}
            onSelect={handleSelectBusquedaCliente}
          />
        )
      }

      {
        openDialogCajaCierre && (
          <CajaCierreDialog
            open={openDialogCajaCierre}
            onClose={handleCloseCajaCierre}
            idCaja={idCaja}
            setIniciar={setIniciar}
            codigoCaja={codigoCaja}
            estadoCaja={estadoCaja}
          />
        )
      }

      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }


      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CajaTable;
